// removed by extract-text-webpack-plugin
module.exports = {"theme":"#3860E2"};


//////////////////
// WEBPACK FOOTER
// ./src/style/element-variables.scss
// module id = L+Pg
// module chunks = 83